<template>
    <line-chart
        :data="chartData"
        :dataset="{ borderWidth: 3, borderColor: '#28a745', backgroundColor: 'rgba(40, 167, 69, 0.1)' }"
        :library="chartOptions"
        :height="300"
    />
</template>

<script>
import { defineComponent } from 'vue'
import { LineChart } from 'vue-chartkick'

export default defineComponent({
    name: 'CommissionWeightedChart',
    components: { LineChart },
    props: {
        weightedData: {
            type: Array,
            required: true
        }
    },
    computed: {
        chartData() {
            console.log('Weighted data received:', this.weightedData);
            if (!this.weightedData || this.weightedData.length === 0) {
                return [];
            }
            return this.weightedData.map(d => [d.date, parseFloat(d.weighted_commission || 0).toFixed(2)]);
        },
        chartOptions() {
            return {
                scales: {
                    x: {
                        type: 'time',
                        time: {
                            unit: 'day'
                        }
                    },
                    y: {
                        beginAtZero: true,
                        max: 10,
                        title: {
                            display: true,
                            text: 'Commission %'
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    }
                }
            };
        }
    }
})
</script>
